import React from 'react';
import './DefaultLayout.css'

const DefaultLayout = ({children}) => {
    return (
        <>
            <main className="p-0 relative">  
                <div className="mb-6">{children}</div>
            </main>
        </>
      );
}

export default DefaultLayout;